import React, { useState } from 'react';
import { Modal, Space, Typography, Radio, Upload, Divider } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { RevxButton } from 'components/RevxButton';
import { toast, success as toastSuccess } from 'components/RevxMessage';
import orderService from 'services/orderService';

const { Text } = Typography;

export const CostDistributionImportModal: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [importType, setImportType] =
    useState<'banner' | 'cost' | undefined>(undefined);
  const [uploading, setUploading] = useState(false);
  const [fileList, setFileList] = useState<any[]>([]);

  const handleOpen = () => {
    setVisible(true);
    setImportType(undefined);
    setFileList([]);
  };

  const handleImport = async () => {
    if (!fileList.length || !importType) {
      toast.error('Please select an import type and a file.');
      return;
    }

    setUploading(true);
    try {
      const file = fileList[0];
      if (importType === 'banner') {
        await orderService.importBannerConfiguration(file);
        toastSuccess('Banner configuration imported successfully.');
      } else {
        await orderService.importCostDistribution(file);
        toastSuccess('Cost distribution imported successfully.');
      }
      setVisible(false);
    } catch (error: any) {
      toast.error(error.originalMessage || 'Import failed.');
    } finally {
      setUploading(false);
    }
  };

  return (
    <>
      <RevxButton key="import-cost" brandGreen onClick={handleOpen}>
        Import Cost Distribution
      </RevxButton>
      <Modal
        title="Import Configuration"
        visible={visible}
        onCancel={() => setVisible(false)}
        onOk={handleImport}
        confirmLoading={uploading}
        okButtonProps={{ disabled: !importType || !fileList.length }}
        destroyOnClose
      >
        <Space direction="vertical" style={{ width: '100%' }}>
          <Text strong>Select Import Type:</Text>
          <Radio.Group
            onChange={(e) => setImportType(e.target.value)}
            value={importType}
          >
            <Radio value="banner">Banner Configuration</Radio>
            <Radio value="cost">Cost Distribution</Radio>
          </Radio.Group>

          {importType && (
            <>
              <Divider style={{ margin: '12px 0' }} />
              <Text strong>Upload Excel File (.xlsx):</Text>
              <Upload
                accept=".xlsx"
                beforeUpload={(file) => {
                  setFileList([file]);
                  return false;
                }}
                fileList={fileList}
                onRemove={() => setFileList([])}
              >
                <RevxButton icon={<UploadOutlined />}>Select File</RevxButton>
              </Upload>
            </>
          )}
        </Space>
      </Modal>
    </>
  );
};
